import React, { ReactElement } from 'react';
import classes from './CategoryOptionsModal.module.scss';
import Button from 'components/atoms/Button/Button';
import ModalCloseThin from 'components/assets/ModalCloseThin.svg';
import Txt from 'components/atoms/Txt/Txt';
import { clsx } from 'clsx';

export type CategoryOption = {
  name: string;
  tag: string;
  count?: number;
};

export type Props = {
  categories: CategoryOption[];
  onCategorySelect: (tag: string) => void;
  onClose: () => void;
  selectedCategory?: string;
};

function CategoryOptionsModal({
  categories,
  onCategorySelect,
  onClose,
  selectedCategory,
}: Readonly<Props>): ReactElement {
  const handleCategoryClick = (tag: string) => {
    onCategorySelect(tag);
    onClose();
  };

  return (
    <dialog className={classes.root} aria-label="Category options" open>
      <button className={classes.backdrop} onClick={onClose} aria-label="Close modal" />
      <div className={classes.content}>
        <div className={classes.closeButton}>
          <Button buttonType="tertiary" onClick={onClose} aria-label="Close">
            <ModalCloseThin width={16} height={16} />
          </Button>
        </div>

        <div className={classes.categoryList}>
          {categories.map((category) => (
            <button
              key={category.tag}
              className={clsx(
                classes.categoryItem,
                selectedCategory === category.tag && classes.active,
                !category.count && classes.disabled,
              )}
              disabled={!category.count}
              onClick={() => handleCategoryClick(category.tag)}
            >
              <Txt className={classes.categoryName} skipTranslation>
                {category.name}
              </Txt>
              {category.count !== undefined && (
                <span className={clsx(classes.categoryCount, !category.count && classes.disabled)}>
                  {' '}
                  ({category.count})
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </dialog>
  );
}

export default CategoryOptionsModal;
